import { render } from "./addAdmin.vue?vue&type=template&id=62d86aa0"
import script from "./addAdmin.vue?vue&type=script&lang=js"
export * from "./addAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__